import { FieldFilterType } from "../../../../base/types";
import { useAuth } from "../../../../../modules/auth";
import { useCallback } from "react";
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi";
import { useParams } from "react-router-dom";

export const useGetLookupNames = () => {
    const { user } = useAuth();
    const { siteId } = useParams()
    const [readRecords, { isLoading }] = useLazyReadMultipleQuery()

    const getLookupLabel = useCallback(({ value }: { value?: string }): Promise<string> => {
        if (!value || !siteId) {
            return Promise.reject('Invalid parameters');
        }

        const fetchRecord = (tableId: string, field: string): Promise<string | null> => {
            return readRecords({
                userId: user?.userId || '',
                portalId: siteId,
                tableId,
                fieldList: [field],
                recordLimit: 1,
                filters: [
                    { group: 0, filters: [{ field: `${tableId}id`, type: FieldFilterType.Const, value }] }
                ],
            })
                .unwrap()
                .then(data => data.records.length ? data.records[0][field] : null);
        };

        return fetchRecord('slcm_batch', 'slcm_name')
            .then(record => record ?? fetchRecord('slcm_year', 'slcm_name'))
            .then(record => record ?? fetchRecord('slcm_semester', 'slcm_name'))
            .then(record => record ?? fetchRecord('mshied_program', 'mshied_name'))
            .then(record => record ?? fetchRecord('contact', 'fullname'))
            .then(record => record ?? 'Not found')
            .catch(() => Promise.reject('An error occurred during lookup'));
    }, [user, siteId, readRecords]);

    return { getLookupLabel, isLoading }
}